import { Link } from 'react-router-dom';
import { PaymentTerms, SHIPPING_METHOD_LABEL, ShippingMethod } from '../../types/orderPolicy';
import styles from './OrderTermsInfo.module.scss';

interface OrderTermsInfoProps {
  orderId: string;
  shippingMethod?: ShippingMethod | null;
  paymentTerms?: PaymentTerms | null;
  paymentDueDate?: string | null;
  paidAt?: string | null;
  totalPrice?: number | null;
}

function formatDate(value: string): string {
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString('ko-KR');
}

// 주문 상세(주문조회·마이페이지)에 배송 방법, 후불결제 안내, 견적서 다운로드를 함께 보여준다
function OrderTermsInfo({ orderId, shippingMethod, paymentTerms, paymentDueDate, paidAt, totalPrice }: OrderTermsInfoProps) {
  const isPostpaid = paymentTerms === 'POSTPAID';
  const hasPrice = typeof totalPrice === 'number' && totalPrice > 0;

  return (
    <div className={styles.box}>
      <dl className={styles.list}>
        <div>
          <dt>배송 방법</dt>
          <dd>{SHIPPING_METHOD_LABEL[shippingMethod ?? 'SINGLE']}</dd>
        </div>
        <div>
          <dt>결제 방식</dt>
          <dd>
            {isPostpaid ? '후불결제' : '선결제 (시안 최종 승인 후 결제)'}
            {paidAt && <em className={styles.paid}>결제 완료</em>}
          </dd>
        </div>
      </dl>

      {isPostpaid && !paidAt && (
        <p className={styles.postpaid}>
          후불결제가 승인된 주문으로, 결제 전에도 제작 · 배송이 진행됩니다.
          {paymentDueDate && (
            <>
              {' '}
              <strong>{formatDate(paymentDueDate)}</strong>까지 결제를 완료해주세요.
            </>
          )}
        </p>
      )}

      {hasPrice && (
        <Link to={`/estimate/${orderId}`} className={styles.estimateLink}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <path d="m7 10 5 5 5-5" />
            <path d="M12 15V3" />
          </svg>
          견적서 다운로드
        </Link>
      )}
    </div>
  );
}

export default OrderTermsInfo;
